import mobileCheck from './mobile-check';

const utils = {
  formatDateTime(timestamp) {
    function addPadding(value) {
      return value < 10 ? `0${value}` : value;
    }

    let date = new Date(timestamp);
    let dateFormatted = `${date.getFullYear()}/${addPadding(date.getMonth() + 1)}/${addPadding(date.getDate())}`;
    let timeFormatted = `${addPadding(date.getHours())}:${addPadding(date.getMinutes())}`;
    return `${dateFormatted} ${timeFormatted}`;
  },
  iOSUser() {
    return /^(ipad|ipod|iphone)/i.test(navigator.platform) ||
      /^((?!chrome|chromium|android).)*safari/i.test(navigator.userAgent);
  },
  mobileUser() {
    return mobileCheck();
  },
  escapeHTMLTags(text) {
    // Экранизирует HTML-тэги, заменяя "<" и ">" на мнемоники, чтобы вставляемые тэги через innerHTML не работали
    return text.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  },
  replaceBracketUrlsWithAnchors(text) {
    // Matches: "My favorite search engine is [Duck Duck Go](https://duckduckgo.com)"
    var linksWithBracketsPattern = /\[(.*?)\]\((.*?)\)/gi;

    return text.replace(linksWithBracketsPattern, '<a target="_blank" href="$2">$1</a>');
  },
  replaceUrlsWithAnchors(text, anchorClass) {
    // Matches: "http://webcaster.pro", "https://webcaster.pro", "https://www.webcaster.pro"
    // Doesn't matches: <a [href="https://webcaster.pro"]></a>
    // Описание регулярного выражения: https://rdm.inventos.ru/issues/141563#note-13

    var urlPattern = /(?:^|\s)(https?:\/\/\S+)(?![^<]*<\/a>)/gi;

    var isTextHasLinks = urlPattern.test(text);
    if (!isTextHasLinks) return text;

    function shortenUrl(url) {
      const urlObj = new URL(url);

      const isUrlHasParams = urlObj.pathname.length > 1 || urlObj.search || urlObj.hash;
      if (!isUrlHasParams) return url;

      return urlObj.protocol + "//" + urlObj.hostname + '/[...]';
    }

    function replaceUrlWithAnchor(url) {
      return '<a class="' + anchorClass + '" target="_blank" rel="noreferrer" href="' + url + '">' + shortenUrl(url) + '</a>';
    }

    return text.replace(urlPattern, replaceUrlWithAnchor);
  },
  generateAvatar(username) {
    const fillColors = [
      'F55A50', '992BAE', '4856D1', '16AFCA', '009B87', '5AA100',
      'FFA300', 'E7320B', '577889', 'E7289A', 'DB7600', 'FF4D00'
    ];

    const getInitials = (sentence, length = 2) => {
      const words = sentence
        .trim()
        .split(/\s/)
        .filter((item) => Boolean(item.length))
        .slice(0, length);

      // Если одно слово - делаем инициалы из его первых букв.
      if (words.length === 1) {
        return words[0].slice(0, length).toUpperCase();
      }

      return words
        .map(word => word[0].toUpperCase())
        .join('');
    };

    const fillColor = fillColors[Math.floor(Math.random() * fillColors.length)];
    const text = getInitials(username);

    return `data:image/svg+xml,%3Csvg className='vjs-chat-avatar-svg' viewBox='0 0 100 100'
      xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Ccircle r='50' cx='50' cy='50'
      fill='%23${fillColor}' /%3E%3Ctext x='50%25' y='50%25'
      dominant-baseline='mathematical' text-anchor='middle' fill='%23FFFFFF'
      style='font-size: 32px; font-family: Arial, sans-serif;'
      %3E${text}%3C/text%3E%3C/svg%3E
    `;
  }
}

export default utils;
